import type {
    ComposableOptionsBase,
    Credit,
    CreditType,
    SiteMembershipContext
} from '~/types';
import type {
    PaginatedPayload,
    CustomPagination,
    PaginatedRequest
} from 'x1-base/types';
import { useApiUtils } from 'x1-base/composables';
import { useCustomFetch } from '~/composables';
import { omit as lo_omit } from 'es-toolkit';
import { merge as lo_mergeCompat } from 'es-toolkit/compat';

export interface UseCreditOptions extends ComposableOptionsBase {
    type: CreditType;
    siteMembershipContext?: SiteMembershipContext;
}
export function useCredit(options: Partial<UseCreditOptions> = {}) {
    const apiBasePath = `/v1`;
    const useApiUtilsObj = useApiUtils();
    const $_fetch = useCustomFetch();

    async function getCredits(args: PaginatedRequest): Promise<PaginatedPayload<Credit> | Error> {
        const ep = options.type === 'credit' ? 'account-credit-transactions' : 'gift-card-transactions';
        const url = args?.url ?? `${apiBasePath}/${ep}/`;
        const config = { query: {} };

        lo_mergeCompat(config.query, args?.params, {
            context: 'order_list'
        });

        let paginatedPayload: PaginatedPayload<Credit>;

        try {
            const response = await $_fetch<CustomPagination<Credit>>(url, config);

            paginatedPayload = {
                pagination: lo_omit(response, ['results']),
                data: response.results
            };

            return paginatedPayload;
        } catch (err) {
            return useApiUtilsObj.getErrorObj(err);
        }
    }

    return {
        getCredits
    };
}
